import React from 'react';
import ContentWrapper from "../../components/Content";
import ResponsibleGamesContent from './ResponsibleGames';

const ResponsibleGaming = props => {
    return (
        <ContentWrapper contents={ResponsibleGamesContent} title='Responsible Gaming' />
    )
}

export default ResponsibleGaming